<script>
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import formtextarea from "../formcomponet/formtextarea.vue";
import formcheckbox from "../formcomponet/formcheckbox.vue";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import vue2Dropzone from "vue2-dropzone";
import appConfig from "@/app.config";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import VueEasyLightbox from "vue-easy-lightbox";
import news from "@/models/news";
import VueTagsInput from "@johmun/vue-tags-input";
import newstranslations from "./newstranslations.vue";

export default {
  mixins: [apibtoast, apigeneric, news, appConfig],
  props: ["Id", "AddEdit"],
  data() {
    return {
      tag: "",
      tags: [],
      FormData: {},
      content: "",
      plugins: [
        "advlist autolink link image lists charmap print preview hr anchor pagebreak spellchecker",
        "searchreplace wordcount visualblocks visualchars code fullscreen insertdatetime media nonbreaking",
        "save table contextmenu directionality emoticons template paste textcolor",
      ],
      toolbar:
        "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | l      ink image | print preview media fullpage | forecolor backcolor emoticons",
      options: {
        height: 300,
        style_formats: [
          { title: "Bold text", inline: "b" },
          { title: "Red text", inline: "span", styles: { color: "#ff0000" } },
          { title: "Red header", block: "h1", styles: { color: "#ff0000" } },
          { title: "Example 1", inline: "span", classes: "example1" },
          { title: "Example 2", inline: "span", classes: "example2" },
          { title: "Table styles" },
          { title: "Table row 1", selector: "tr", classes: "tablerow1" },
        ],
      },

      editor: ClassicEditor,
      editorConfig: {
        image: {
          toolbar: [
            "imageStyle:full",
            "imageStyle:side",
            "|",
            "imageTextAlternative",
          ],
        },
      },
      editorData: "",
      dropzoneOptions: {
        url:
          this.$config.API_URL +
          "GenericFileUpDownload/UploadFile?pathUrl=Web",
        thumbnailWidth: 100,
        thumbnailHeight: 100,
        maxFilesize: 2,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: { "My-Awesome-Header": "header value" },
      },
      imagelist: [],
      visible: false,
      singleImage: false,
      visibleCaption: false,
      index: 0, // default: 0
      imgs: [],
      dosya_eklendi: 0,
      languages: {},
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    formtextarea,
    formcheckbox,
    vue2Dropzone,
    ckeditor: CKEditor.component,
    VueEasyLightbox,
    VueTagsInput,
    newstranslations,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.tags = [];

      this.imagelist = [];
      this.imgs = [];
      if (this.AddEdit == "Edit") {
        if (
          this.FormData.Imagegallery != null &&
          this.FormData.Imagegallery != ""
        ) {
          this.imagelist = this.FormData.Imagegallery.split(",");

          for (var i = 0; i < this.imagelist.length; i++) {
            this.imgs.push(
              process.env.VUE_APP_FILES_URL + "web/" + this.imagelist[i]
            );
          }
        }

        if (
          this.FormData.SeoKeyword != null &&
          this.FormData.SeoKeyword != ""
        ) {
          this.tags = JSON.parse(this.FormData.SeoKeyword);
        }

        this.LanguagesGet();
      }
    },
  },
  methods: {
    onSubmit() {
      this.FormData.Websiteid = window.$cookies.get("website");

      this.FormData.SeoKeyword = JSON.stringify(this.tags);

      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.dosya_eklendi == 1) {
          this.dosyalari_yukle();
        } else {
          if (this.AddEdit == "Add") {
            this.Post("news", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("news");
                this.LanguagesGet();
              }
            });
          } else {
            this.Update("news", this.FormData).then((res) => {
              if (res) {
                this.$emit("TableUpdate");
                this.$bvModal.hide("news");
              }
            });
          }
        }
      }
    },

    afterUploadComplate: async function (response) {
      let gelen = JSON.parse(JSON.parse(response.xhr.response));

      this.imagelist.push(gelen.Data.filename);
      this.FormData.Imagegallery = this.imagelist.toString();
    },

    afterUploadAllComplate() {
      if (this.AddEdit == "Add") {
        this.Post("news", this.FormData).then((res) => {
          if (res) {
            this.$emit("TableUpdate");
            this.$bvModal.hide("news");
            this.dosya_eklendi = 0;
          }
        });
      } else {
        this.Update("news", this.FormData).then((res) => {
          if (res) {
            this.$emit("TableUpdate");
            this.$bvModal.hide("news");
            this.dosya_eklendi = 0;
          }
        });
      }
    },

    vfileAdded(file) {
      this.dosya_eklendi = 1;
      console.log(file.name);
    },

    dosyalari_yukle() {
      this.$refs.myVueDropzone.processQueue();
    },

    showImg(index) {
      this.index = index;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },
    handleCaptionHide() {
      this.visibleCaption = false;
    },

    resim_sil(index) {
      this.imgs = [];
      this.imagelist.splice(index, 1);
      this.FormData.Imagegallery = this.imagelist.toString();

      for (var i = 0; i < this.imagelist.length; i++) {
        this.imgs.push(
          process.env.VUE_APP_FILES_URL + "web/" + this.imagelist[i]
        );
      }
    },

    Get() {},
    LanguagesGet() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };

      this.ActionsGet({ Service: "languages", Page: Page }).then((res) => {
        this.languages = res.Data;
      });
    },
  },
};
</script>
<template>
  <Loader>
    <b-modal
      id="news"
      size="xl"
      :title="
        this.AddEdit == 'Edit'
          ? $t('news.AddEdit.FormTitleEdit')
          : $t('news.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >
      <b-tabs content-class="p-3 text-muted">
        <b-tab active class="border-0">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <country-flag country="tr" size="small" />Türkçe</span
            >
          </template>
          <Form @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6">
                <formcombobox
                  :FormDataType="FormDataType.Newstype"
                  :Value="FormData.Newstype"
                  :v="$v.FormData.Newstype"
                  @input="FormData.Newstype = $event"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <forminput
                  :FormDataType="FormDataType.Title"
                  :Value="FormData.Title"
                  :v="$v.FormData.Title"
                  @input="FormData.Title = $event"
                />
              </div>
            </div>

            <!--    <div class="row">
      <div class="col-12">
       
            <b-form-group
              id="example text"
              :label="FormDataType.Description.FieldTitle"
              label-for="text"
            >
              <tinymce
              id="d1"
              v-model="FormData.Description"
              :plugins="plugins"
              :toolbar="toolbar"
              :other_options="options"
            ></tinymce>

              <div v-if="$v.FormData.Description.$error" class="invalid-feedback">
                <span v-if="$v.FormData.Description.required == false">{{
                  $t("ValidationMessage.required")
                }}</span>
              </div>
            </b-form-group>
      </div>
    </div>   -->

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  :class="title_position"
                  :label-cols-lg="labels_lg"
                  id="example text"
                  :label="FormDataType.Description.FieldTitle"
                  label-for="text"
                >
                  <ckeditor
                    v-model="FormData.Description"
                    :editor="editor"
                    :config="editorConfig"
                  ></ckeditor>
                </b-form-group>
              </div>
            </div>
            <br />
            <br />
            <h4>{{ this.$t("news.AddEdit.Imagegallery") }}</h4>
            <hr />

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  :class="title_position"
                  :label-cols-lg="labels_lg"
                  id="example text"
                  label-for="text"
                >
                  <vue2Dropzone
                    id="myVueDropzone"
                    ref="myVueDropzone"
                    :use-custom-slot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="vfileAdded"
                    @vdropzone-complete="afterUploadComplate"
                    @vdropzone-queue-complete="afterUploadAllComplate"
                  >
                    <div class="dropzone-custom-content">
                      <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                      <h4>{{ this.$t("news.AddEdit.ImagegalleryNote") }}</h4>
                    </div>
                  </vue2Dropzone>
                </b-form-group>
              </div>
            </div>
            <br />

            <div class="popup-gallery d-flex flex-wrap">
              <div
                v-for="(src, index) in imgs"
                :key="index"
                class="float-left"
                align="right"
              >
                <i @click="resim_sil(index)" class="fas fas fa-times"></i><br />
                <img
                  @click="() => showImg(index)"
                  :src="src"
                  width="120"
                  style="margin-left: 20px"
                />
              </div>
              <vue-easy-lightbox
                :visible="visible"
                :imgs="imgs"
                :index="index"
                @hide="handleHide"
              ></vue-easy-lightbox>
            </div>

            <br />
            <br />

            <h4>{{ this.$t("news.AddEdit.SeoAyarlari") }}</h4>
            <hr />

            <div class="row">
              <div class="col-md-6">
                <forminput
                  :FormDataType="FormDataType.SeoTitle"
                  :Value="FormData.SeoTitle"
                  :v="$v.FormData.SeoTitle"
                  @input="FormData.SeoTitle = $event"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  id="example text"
                  :label="FormDataType.SeoKeyword.FieldTitle"
                  label-for="text"
                >
                  <vue-tags-input
                    style="max-width: unset"
                    placeholder=""
                    v-model="tag"
                    :tags="tags"
                    @tags-changed="(newTags) => (tags = newTags)"
                  />
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <formtextarea
                  :FormDataType="FormDataType.SeoDescription"
                  :Value="FormData.SeoDescription"
                  :v="$v.FormData.SeoDescription"
                  @input="FormData.SeoDescription = $event"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <formcheckbox
                  :title_position="'mb-3'"
                  :labels_lg="3"
                  :FormDataType="FormDataType.Islightbox"
                  :Value="FormData.Islightbox"
                  :v="$v.FormData.Islightbox"
                  @input="FormData.Islightbox = $event"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <b-form-group
                  id="example text"
                  :label="FormDataType.Startdate.FieldTitle"
                  label-for="text"
                >
                  <b-form-input
                    v-model="FormData.Startdate"
                    id="date"
                    type="datetime-local"
                  ></b-form-input>

                  <div
                    v-if="$v.FormData.Startdate.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="$v.FormData.Startdate.required == false">{{
                      $t("ValidationMessage.required")
                    }}</span>
                  </div>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <b-form-group
                  id="example text"
                  :label="FormDataType.Enddate.FieldTitle"
                  label-for="text"
                >
                  <b-form-input
                    v-model="FormData.Enddate"
                    id="date"
                    type="datetime-local"
                  ></b-form-input>

                  <div
                    v-if="$v.FormData.Enddate.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="$v.FormData.Enddate.required == false">{{
                      $t("ValidationMessage.required")
                    }}</span>
                  </div>
                </b-form-group>
              </div>
            </div>
            <hr />
            <button class="btn btn-primary" type="submit">
              {{ $t("news.AddEdit.Button") }}
            </button>
          </Form>
        </b-tab>
        <b-tab v-for="(Data, index) in languages" :key="index">
          <template v-if="Data.Shorttitle != 'tr'" v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <country-flag :country="Data.Flag" size="small" />{{
                Data.Title
              }}</span
            >
          </template>

          <newstranslations
            :lang_id="Data.Id"
            :news_id="FormData.Id"
            :Websiteid="FormData.Websiteid"
            @TableUpdate="Get"
          />
        </b-tab>
      </b-tabs>
    </b-modal>
  </Loader>
</template>
